module.exports = __webpack_public_path__ + "img/xcx.66c9c3af.jpg";